import html2canvas from "html2canvas";

// Returns false on failure instead of throwing, so callers can show a toast
// without needing their own try/catch. `options` is passed through to
// html2canvas — e.g. `onclone(clonedDocument, clonedNode)` to adjust only
// the off-screen copy being captured, leaving the page itself untouched.
export const exportNodeAsPng = async (node, filename = "export", options = {}) => {
  if (!node) return false;
  try {
    const canvas = await html2canvas(node, { backgroundColor: "#ffffff", scale: 2, ...options });
    const dataUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `${filename}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } catch (error) {
    console.error("Error exporting PNG:", error);
    return false;
  }
};
